/**
 * Turns optional `slaDemo` ages (relative to now) into absolute `slaMeta` for breach checks.
 * @param {Record<string, unknown>} conv
 * @param {number} nowMs
 * @returns {Record<string, unknown>}
 */
export function materializeConversationSla(conv, nowMs) {
  const d = conv.slaDemo;
  if (!d || typeof d !== "object") {
    return { ...conv };
  }

  const firstUserAgeSec = typeof d.firstUserAgeSec === "number" ? d.firstUserAgeSec : 120;
  const lastUserAgeSec = typeof d.lastUserAgeSec === "number" ? d.lastUserAgeSec : firstUserAgeSec;
  const hasHumanAgentReply = Boolean(d.hasHumanAgentReply);

  const lastUserAt = new Date(nowMs - lastUserAgeSec * 1000).toISOString();
  const firstUserAt = new Date(nowMs - firstUserAgeSec * 1000).toISOString();

  let firstHumanAgentAt = null;
  let lastHumanAgentAt = null;

  if (hasHumanAgentReply) {
    const delaySec = typeof d.humanFirstReplyAfterFirstUserSec === "number" ? d.humanFirstReplyAfterFirstUserSec : 25;
    firstHumanAgentAt = new Date(new Date(firstUserAt).getTime() + delaySec * 1000).toISOString();
  }

  if (hasHumanAgentReply && typeof d.lastHumanAgentBeforeLastUserSec === "number") {
    lastHumanAgentAt = new Date(new Date(lastUserAt).getTime() - d.lastHumanAgentBeforeLastUserSec * 1000).toISOString();
  } else if (hasHumanAgentReply && typeof d.lastHumanAgentAgeSec === "number") {
    lastHumanAgentAt = new Date(nowMs - d.lastHumanAgentAgeSec * 1000).toISOString();
  }

  return {
    ...conv,
    slaMeta: {
      firstUserAt,
      lastUserAt,
      firstHumanAgentAt,
      lastHumanAgentAt,
    },
  };
}
